const url = '/frequent-flyers';
const Provider = 'FrequentFlyers';
const dbModel = 'FrequentFlyers';

export { url, Provider, dbModel };
export const TABLE_NAME = 'frequentflyers';
